// Sprint 27 item 2 (roadmap 62): while the first minute runs, the page shows the knock and nothing else.
// The rooms, the wallet, the name field and the links appear after the second door. Pure, so a test can hold it.
export const firstMinuteChrome = active => ({ rooms: !active, wallet: !active, name: !active, look: !active, roadmap: !active, leaders: !active, stairwell: !active, coin: !active, discord: !active });

// The rule line is drawn as large as fits one line, never under this many screen pixels (at the 2x scale) and never over MAX (26 px or more fits one line at 390 px: test/first-minute-page.test.js).
export const RULE_MIN_PX = 16;
export const RULE_MAX_PX = 32;
// widthAt(px): the line's width in screen px at that size; room: the width on screen it may use. The largest whole size that fits.
export function ruleFitPx(widthAt, room, min = RULE_MIN_PX, max = RULE_MAX_PX) {
  for (let px = max; px > min; px--) if (widthAt(px) <= room) return px;
  return min;
}
